import React, { useEffect, useState } from 'react'
import {
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  PageHeader,
} from '../../../../components'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { Column } from 'primereact/column'
import useAssocUsuarioOperacaoPatrimonial, {
  LOADING_MESSAGE,
} from './AssocUsuarioOperacaoPatrimonialHook'
import { tableCellCentered } from '../../../../assets/js/styles'

function AssocUsuarioOperacaoPatrimonial({ history, dispatch }) {
  const usuario = history.location.state.usuario

  // Hook
  const { state, localDispatch } = useAssocUsuarioOperacaoPatrimonial()
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    localDispatch.onInit()
  }, [])

  useEffect(() => {
    if (state.selectedLocal !== '') {
      localDispatch.loadAssociacoes()
    }
  }, [state.selectedLocal])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOADING_MESSAGE.FETCH:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
        localDispatch.onFetchInfo(usuario)
        break
      case LOADING_MESSAGE.FETCH_ASSOCIACOES:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
        localDispatch.fetchAssociacoes(state.selectedLocal)
        break
      case LOADING_MESSAGE.ASSOCIANDO:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
        localDispatch.associacaoHandler(state.selectedAssociacao)
        break
      case LOADING_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.onResetState()
    }
  }, [state.errorMessage])

  // Render
  return (
    <>
      <PageHeader>
        Associação Usuário X Operação de Movimentação de Patrimônio - &nbsp;
        <strong>{usuario.name}</strong>
      </PageHeader>
      <CustomPanel onNovo={() => localDispatch.onNovoClick()} onVoltar={history.goBack}>
        <div className="p-grid">
          <div className="p-col-4">
            <CustomDropdown
              filter={true}
              value={state.selectedLocal}
              onChange={localDispatch.onLocalMovimentacaoChange}
              label={'Local de Movimentação'}
              options={state.locaisMovimentacao}
              optionLabel={'local_movimentacao_name'}
            />
          </div>
          <div className="p-col-12">
            <DataTable
              value={state.associacoes}
              emptyMessage={'Selecione o Local de Movimentação desejado'}
              globalFilter={globalFilter}
              header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
            >
              <Column
                header={'#'}
                body={item => (
                  <CustomCheckbox
                    checked={
                      item.user_local_operacao_id !== null &&
                      item.user_local_operacao_id !== undefined
                    }
                    onChange={() => localDispatch.onRowClicked(item)}
                  />
                )}
                style={tableCellCentered(80)}
              />
              <Column field={'operacao_name'} header={'Operação de Movimentação'} />
            </DataTable>
          </div>
        </div>
      </CustomPanel>
    </>
  )
}

export default connect()(withRouter(AssocUsuarioOperacaoPatrimonial))
